import type { AuthenticateUser } from "../types/AuthenticateUser.js";
import type { AuthenticateUserResponse } from "../types/AuthenticateUserResponse.js";
import { makeAuthenticateUserPayload } from "./make-authenticate-user-payload.js";
import { postJSON } from "./post-json.js";

export const authenticateUser: AuthenticateUser = async ({
  password,
  username,
}) => {
  const authenticateUserPayload = makeAuthenticateUserPayload({
    password,
    username,
  });

  return postJSON<AuthenticateUserResponse>({
    payload: authenticateUserPayload,
    url: "v4/auth/signin",
  });
};
